import { DotLegalSelectOption } from "@common/components/dotLegalMultiSelect/DotLegalMultiSelect.types";

// Every management report section filters its rows through the same two steps: collect the distinct values present in
// the rows into dropdown options, then keep the rows matching whatever the user picked. The audit and assessment
// reports share these so their dropdowns also share one ordering.
export function toSelectOptions(values: Array<{ id: string; name: string } | undefined>): Array<DotLegalSelectOption> {
    const options: Array<DotLegalSelectOption> = [];

    values.forEach((value) => {
        if (value && !options.some((option) => option.id === value.id)) {
            options.push({ id: value.id, name: value.name });
        }
    });

    return options.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
}

export function filterBySelection<T>(rows: Array<T>, selected: Array<string>, valueOf: (row: T) => string | undefined) {
    if (selected.length === 0 || selected[0] === "") {
        return rows;
    }

    return rows.filter((row) => {
        const value = valueOf(row);

        return value !== undefined && selected.includes(value);
    });
}
